import { render, staticRenderFns } from "./NewslettersUsers.vue?vue&type=template&id=2e5bd3b8&scoped=true&"
import script from "./NewslettersUsers.vue?vue&type=script&lang=js&"
export * from "./NewslettersUsers.vue?vue&type=script&lang=js&"
import style0 from "./NewslettersUsers.vue?vue&type=style&index=0&id=2e5bd3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bd3b8",
  null
  
)

export default component.exports